import React from "react";
import {
    View,
    Text,
    StyleSheet,
    Svg,
    Path,
    G,
    Circle,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
    container: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    },
    icon: {
        marginRight: "3px"
    },
    text: {
        fontSize: "8px",
        color: "#415363",
        fontWeight: "bold",
    }
});

const Icon = () => (
    <Svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 40 40">
        <G id="Tie_Vote_Icon" transform="translate(-120.477 -96.775)">
            <Path id="Ellipse_717-7" data-name="Ellipse 717-7" d="M20,0A20,20,0,1,1,0,20,20,20,0,0,1,20,0Z" transform="translate(120.476 96.775)" fill="#415364" />
            <G id="np_tic-tac-toe_223089_000000" transform="translate(130.825 107.188)">
                <Path id="Path_36454" data-name="Path 36454" d="M17.734,31.946H2.43a.348.348,0,1,1,0-.7h15.3a.348.348,0,1,1,0,.7Z" transform="translate(0 -24.295)" fill="#fff" />
                <Path id="Path_36455" data-name="Path 36455" d="M17.738,65.281H2.434a.348.348,0,1,1,0-.7h15.3a.348.348,0,1,1,0,.7Z" transform="translate(-0.003 -52.065)" fill="#fff" />
                <Path id="Path_36456" data-name="Path 36456" d="M31.6,18.086a.348.348,0,0,1-.348-.348V2.434a.348.348,0,0,1,.7,0v15.3A.348.348,0,0,1,31.6,18.086Z" transform="translate(-24.298 0)" fill="#fff" />
                <Path id="Path_36457" data-name="Path 36457" d="M64.93,18.086a.348.348,0,0,1-.348-.348V2.434a.348.348,0,1,1,.7,0v15.3A.347.347,0,0,1,64.93,18.086Z" transform="translate(-52.065 0)" fill="#fff" />
                <Path id="Path_36458" data-name="Path 36458" d="M7.989,9.728A1.739,1.739,0,1,1,9.728,7.989,1.741,1.741,0,0,1,7.989,9.728Zm0-2.782A1.043,1.043,0,1,0,9.033,7.989,1.045,1.045,0,0,0,7.989,6.946Z" transform="translate(-3.472 -3.469)" fill="#fff" />
                <Path id="Path_36459" data-name="Path 36459" d="M74.653,43.061a1.739,1.739,0,1,1,1.739-1.739A1.741,1.741,0,0,1,74.653,43.061Zm0-2.783A1.043,1.043,0,1,0,75.7,41.321,1.045,1.045,0,0,0,74.653,40.278Z" transform="translate(-59.006 -31.236)" fill="#fff" />
                <Path id="Path_36460" data-name="Path 36460" d="M41.321,76.393a1.739,1.739,0,1,1,1.739-1.739A1.741,1.741,0,0,1,41.321,76.393Zm0-2.783a1.043,1.043,0,1,0,1.043,1.043A1.045,1.045,0,0,0,41.321,73.61Z" transform="translate(-31.239 -59.003)" fill="#fff" />
                <Path id="Path_36461" data-name="Path 36461" d="M39.93,43.064a.348.348,0,0,1-.247-.593l2.783-2.783a.348.348,0,1,1,.492.492l-2.783,2.783a.347.347,0,0,1-.245.1Z" transform="translate(-31.239 -31.239)" fill="#fff" />
                <Path id="Path_36462" data-name="Path 36462" d="M42.709,43.064a.349.349,0,0,1-.247-.1L39.68,40.179a.348.348,0,1,1,.492-.492l2.783,2.783a.348.348,0,0,1-.245.593Z" transform="translate(-31.236 -31.239)" fill="#fff" />
                <Path id="Path_36463" data-name="Path 36463" d="M9.377,76.4a.349.349,0,0,1-.247-.1L6.348,73.511a.348.348,0,1,1,.492-.492L9.622,75.8a.348.348,0,0,1,0,.492.343.343,0,0,1-.245.1Z" transform="translate(-3.469 -59.006)" fill="#fff" />
                <Path id="Path_36464" data-name="Path 36464" d="M6.594,76.4a.348.348,0,0,1-.247-.593L9.131,73.02a.348.348,0,0,1,.492.492L6.84,76.294a.343.343,0,0,1-.245.1Z" transform="translate(-3.469 -59.006)" fill="#fff" />
                <Path id="Path_36465" data-name="Path 36465" d="M73.262,9.728a.348.348,0,0,1-.247-.593L75.8,6.352a.348.348,0,0,1,.492.492L73.508,9.626a.343.343,0,0,1-.245.1Z" transform="translate(-59.006 -3.469)" fill="#fff" />
                <Path id="Path_36466" data-name="Path 36466" d="M76.045,9.728a.349.349,0,0,1-.247-.1L73.016,6.843a.348.348,0,1,1,.492-.492L76.29,9.135a.348.348,0,0,1-.245.593Z" transform="translate(-59.006 -3.469)" fill="#fff" />
            </G>
        </G>
    </Svg>

)

const TieVoteIcon = () => (
    <View style={styles.container}>
        <View style={styles.icon}>
            <Icon />
        </View>
        <Text style={styles.text}>Tie Vote</Text>
    </View>
);

export default TieVoteIcon;
